import { render, staticRenderFns } from "./Campbell.vue?vue&type=template&id=774d1c87"
import script from "./Campbell.vue?vue&type=script&lang=js"
export * from "./Campbell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports